import { Switch } from "shared/components/forms/Switch";
import { Tabs } from "shared/components/BaseTabs";
import type { Tab } from "shared/components/BaseTabs/types";
import { NotificationKind } from "../types";

interface LayoutHeaderProps {
  unreadOnly: boolean;
  toggleUnreadOnly: () => void;
  tab: string;
  onTabChange: (tab: string) => void;
  unreadTotalCount: number;
  unreadMentionCount: number;
  unreadAssignedCount: number;
  unreadMessageCount: number;
  unreadCallCount: number;
  // Voice is a partner feature; hide the tab entirely rather than showing an
  // empty one, the way every other voice affordance in the portal behaves.
  showCallsTab: boolean;
}

const renderTabLabel = (label: string, count: number) => (
  <span>
    {label}{" "}
    {count ? (
      <span className="px-1.5 py-0.5 bg-primary-500 text-white text-xs rounded-md font-bold">
        {count}
      </span>
    ) : (
      ""
    )}
  </span>
);

export const LayoutHeader = (props: LayoutHeaderProps) => {
  const {
    unreadOnly,
    toggleUnreadOnly,
    tab,
    onTabChange,
    unreadMentionCount,
    unreadAssignedCount,
    unreadMessageCount,
    unreadCallCount,
    showCallsTab
  } = props;

  const tabs: Tab<string>[] = [
    // Leads the row, as designed: a missed call is the most time-sensitive
    // thing the bell can hold.
    ...(showCallsTab
      ? [
          {
            value: NotificationKind.Call,
            label: renderTabLabel("Calls", unreadCallCount)
          }
        ]
      : []),
    {
      value: NotificationKind.Mention,
      label: renderTabLabel("Mentions", unreadMentionCount)
    },
    {
      value: NotificationKind.Assigned,
      label: renderTabLabel("Assigned", unreadAssignedCount)
    },
    {
      value: NotificationKind.Message,
      label: renderTabLabel("Messages", unreadMessageCount)
    }
  ];

  return (
    <div className="divide-y divide-alpha-40">
      <div className="flex gap-4 p-6">
        <h1 className="text-2xl font-bold">Notifications</h1>
        <Switch
          label="Only unread"
          wrapperClassName="mt-2"
          className="text-sm font-medium text-content-500"
          checked={unreadOnly}
          onChange={() => toggleUnreadOnly()}
        />
      </div>

      <div className="p-4 pb-0">
        <Tabs
          size="sm"
          tabStyle="line"
          fullWidthTabs={false}
          tabs={tabs}
          active={tab}
          onChange={(t) => onTabChange(t)}
        />
      </div>
    </div>
  );
};
